export default __webpack_public_path__ + "static/career-img-1-42adb06f76f4d7f30f6175d1a4d2eef9.png";